<template>
    <div class="vm-action-qr-code flex-box flex-center" :class="[browser_size, GL.ENV.is_ios && GL.ENV.is_afd_client ? 'ios-client' : '']">
      <swiper v-if="has_load" :options="swiperOption" ref="dom_swiper" class="mt48" @slideChangeTransitionEnd="slideChangeTransitionEnd">
        <swiper-slide v-for="(item, i) in tickets" :key="i" class="flex-box flex-center">
          <div class="qr-box">
            <div class="p16">
              <qriously v-if="is_async_component_loaded" :value="host_wrapper(item.id)" :size="192" class="flex-box flex-center"/>
            </div>
            <div class="flex-box flex-center relative" v-if="browser_size == 'small'">
              <span class="black-circle big left"></span>
              <span class="black-circle big right"></span>
              <span class="black-circle" :class="{mr10: j != 8}" v-for="(num, j) in 9" :key="j"></span>
            </div>
            <div class="line" v-if="browser_size != 'small'"></div>
            <div class="flex-box p16">
              <div v-if="params.plan.pic" class="img-box mr8">
                <pic :src="params.plan.pic" width="48" height="48"/>
              </div>
              <div class="black-8 lh1 fs12">
                <!-- params:{{params}} -->
                <div class="flex-box pt8">
                  <span>参展人</span>
                  <span class="ml8">{{item.name}}</span>
                </div>
                <div class="mt8">{{item.id_card}}</div>
              </div>
            </div>
          </div> 
        </swiper-slide> 
        <template v-if="tickets.length > 1 && browser_size != 'small'">
          <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
          <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
        </template>
      </swiper>
      <div class="page-box fs-20-16 mq" v-if="tickets.length > 1">{{activeIndex}} / {{tickets.length}}</div>
      <!-- <div class="line mt20 mb20"></div>
      <div class="item flex-box flex-a-center flex-bet fs16 black-8 gl-hover-text" @click="tab(2)">
          <span>日本語</span>
          <i class="afd afd-arrow-right fs14 black-3"></i>
      </div> -->
    </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import {
  GET_ORDER_TICKETS,
} from "@/api/config";
export default {
  name: "action-qr-code",
  props: {
    params: {
      default() {
        return {};
      }
    }
  },
  data() {
    return {
        status:1,
        is_async_component_loaded:false,
        has_load:false,
        val:'',
        tickets:[],
        activeIndex:1,
        swiperOption: {
        // Enable lazy loading
          initialSlide:0,
          lazy: true,
          zoom: true,
          zoomToggle :false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        }
    };
  },
  inject:['app_action_sheet'],
  computed: {
    ...mapState("app", ["browser_size",'session_user']),
    swiper() {
      return this.$refs.dom_swiper.swiper
    },
  },
  beforeDestroy(){
  },
  async beforeMount() {
    this.get_tickets();
    let VueQriously = await import("vue-qriously");
    Vue.use(VueQriously);
    this.is_async_component_loaded = true;
  },
  mounted() {
    // console.log(this.params)
  },
  methods: {
    close(){
      this.app_action_sheet('close')
    },
    slideChangeTransitionEnd(){
      this.activeIndex = this.swiper.activeIndex + 1
    },
    host_wrapper(id){
      return location.origin + `/order/inspect?out_trade_no=${this.params.out_trade_no}&id=${id}`;
    },
    async get_tickets() {
      if (this.$http.is_run(GET_ORDER_TICKETS)) {
        return false;
      }
      let data = await this.$http.$axios(GET_ORDER_TICKETS,{
        out_trade_no:this.params.out_trade_no
      });
      this.has_load = true;
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }
      this.tickets = data.data;
    },
  }
};
</script>

<style lang="stylus" scoped>
.vm-action-qr-code {
    // background: #231F1F;
    // padding:24px 0px;
    box-sizing: border-box;
    width:350px;
    padding-bottom:100px;
    &.ios-client{
      padding-bottom:200px !important;
      .page-box{
        bottom:164px;
      }
    }
    // transform:translate(0,100%);
    // transition:all .2s ease-out;
    // &.on{
    //     transform:translate(0,0);
    // }
    .qr-box{
      // border: 1px solid #e3e3e3;
      border-radius:10px;
      background: $white;
      box-shadow:$layer-shadow;
      // width:224px;
    }
    .page-box{
      position:absolute;
      left:50%;
      color:$white;
      text-shadow: 1px 1px $black-1;
      top: 50%;
      transform: translate(-50%, 189px);
    }
    .img-box{
      width:48px;
      height:48px;
    }
    .black-circle{
      width:10px;
      height:10px;
      background: #231F1F;
      border-radius:100%;
      &.big{
        width:10px;
        height:20px;
        position:absolute;
        &.left{
          left:-1px;
          // transform:translateX(-50%)
          border-radius: 0px 10px 10px 0;
        }
        &.right{
          right:-1px;
          border-radius: 10px 0px 0px 10px;
          // transform:translateX(50%)
        }
      }
    }
    &.small {
      background: #231F1F;
      min-width:auto;
      // background: $white;
      border-radius:8px 8px 0 0;
      // padding:24px 0 40px 0;
      position:fixed;
      left:0;
      width:100%;
      bottom:0;
      .page-box{
        bottom:64px;
        transform:translateX(-50%);
        top:auto;
      }
    }
    &.safe-space{
      padding-bottom:$safe-space;
    }
}
</style>
